import { Box, Container, Typography } from "@mui/material";
import React from "react";
import QrReader from "react-qr-scanner";
import BoltIcon from "@mui/icons-material/Bolt";
import { useTranslation } from "react-i18next";
export default function QrCodeScanner(props) {
  const {t}= useTranslation();
  const previewStyle = {
    height: "100%",
    with: "100%",
    objectFit: "fill",
  };
  const containerStyle = {
    width: "20rem",
    height: "20rem",
    marginTop: "10%",
    position: "absolute",
    border: "0.2rem solid #FFF",
  };
  const handleScan = (data) => {
    if (props.setQrData && data && data.text) {
      props.setQrData(data.text);
    }
  };

  return (
    <Container
      disableGutters
      maxWidth="xl"
      sx={{
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        maxWidth: "100vw",
        overflow: "hidden",
      }}
    >
      <Box
        display={"block"}
        sx={{
          padding: 1,
          backgroundColor: "#F8FAFF",
          borderRadius: 7,
          position: "absolute",
          display: "flex",
          flexFlow: "row",
          justifyContent: "center",
          top: 50,
        }}
      >
        <BoltIcon />
        <Typography
          color={"#000"}
          fontSize={14}
          fontWeight={400}
          paddingLeft={2}
          paddingRight={2}
        >
          {t('ScanQR')}
        </Typography>
      </Box>
      <Box style={containerStyle}></Box>
      <QrReader
        delay={300}
        style={previewStyle}
        onError={console.log}
        onScan={handleScan}
        constraints={{
          video: { facingMode: "environment" },
        }}
      />
    </Container>
  );
}
